<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="height-100px row p-0 m-0 background-primary-blue w-100 border-bottom border-dark-subtle p-3 z-max d-flex justify-content-center align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl p-3"></i>
        </div>
        <div class="col-8">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-auto fs-main text-center color-white">Add paddocks</div>
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="video-container">
            <iframe
                src="https://portal.moovement.co/how-to-draw-your-farm.html"
                title="How to draw your farm"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen>
            </iframe>
        </div>
        <div class="text-container p-3">
            Create a KML file for your paddocks in
            <a href="https://earth.google.com/" target="_blank">Google Earth</a>
            following the instuctions in the video above.
            Submit that KML file below to add the paddocks to your farm.
        </div>
        <input (input)="setKmlFile($event.target)"
            class="form-control"
            datatype="text"
            id="kml"
            name="kml"
            type="file"
            accept="application/vnd.google-earth.kml+xml">
    </div>
</div>
